import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import uk from "./locales/uk.json";
import en from "./locales/en.json";

const resources = {
  uk: { common: uk },
  en: { common: en },
};

const DEFAULT_LANG = "uk";
const SUPPORTED_LANGS = ["uk", "en"];

// Зберігаємо вибір мови в localStorage під цим ключем
const STORAGE_KEY = "sv_city_trans_lang";

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  } catch (_) {}
  return null;
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  defaultNS: "common",
  fallbackLng: "uk",
  supportedLngs: SUPPORTED_LANGS,
  lng: getStoredLanguage() || DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
    lookupLocalStorage: STORAGE_KEY,
  },
});

// При зміні мови зберігаємо в localStorage
i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (_) {}
});

export default i18n;
export { DEFAULT_LANG, SUPPORTED_LANGS, STORAGE_KEY };
